module.exports = __webpack_public_path__ + "images/c9adc2b010129fb6383c38a5a66446c5.communication.svg";